/* eslint-disable @typescript-eslint/naming-convention */

import { BrandingColorMap } from '../../branding-color-map.interface';

export const BRANDING_COLOR_MAP_ACS: BrandingColorMap = {
  'primary-100': '#D9EEE7',
  'primary-200': '#A7D6C7',
  'primary-400': '#005D45',
  'primary-600': '#005D45',
  'primary-800': '#003224',
};
